export default "__VITE_ASSET__DfM2rfol__"